<template>
  <div>
    <PageHeading
      :default-heading="pageHeader()"
      :edit-heading="pageHeader()"
    />
    <form novalidate="novalidate" @submit.prevent>
      <div class="pvd-container container-divider">
        <p>
          We'll send a text to the mobile number you provided for
          {{ idVerificationName() }} <strong> ({{ maskedPhoneNumber() }}) </strong>
        </p>
      </div>
      <NavigationComponent @next-action="handleWidgetSubmit" />
    </form>
  </div>
</template>

<script>
import utilityFunctions from '../mixins/utility';
import PageHeading from '../components/PageHeading.vue';
import validationHelper from '../mixins/validationHelper';
import widgetHelper from '../mixins/widgetHelper';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import NavigationComponent from '../components/NavigationComponent.vue';

export default {
  name: 'TrustDocVerifyResendSMS',
  components: {
    NavigationComponent,
    PageHeading,
  },
  mixins: [
    utilityFunctions,
    validationHelper,
    widgetHelper,
    dataHelper,
    dataSanitize,
  ],
  mounted() {
    this.$store.commit('currentState/updateField', { path: 'stateName', value: 'trust-doc-verify-resend-sms' });
  },
  methods: {
    pageHeader() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return 'Send a new verification link to '.concat(`${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`);
      }
      return 'Send a new verification link to '.concat(`${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`);
    },
    idVerificationName() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return `${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`;
      }
      return `${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`;
    },
    maskedPhoneNumber() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      const phoneNumber = Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex) ? formData.additionalUsers[currentUserIndex]?.dayPhone : formData.primaryUser?.dayPhone;
      return '***-***-'.concat(phoneNumber.replace(/\D/g, '').slice(-4));
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
.top-margin-zero {
  margin-top: 0;
}

</style>
